import { PercentMaskProcessing } from './percent';

export class PercentWithFixedDecimalsMaskProcessing extends PercentMaskProcessing {
  protected fixedDecimals = 3;
  protected min = 0;
}
